export const CALENDLY_URL =
  "https://calendly.com/gollayogiswarnaidu/45min?hide_event_type_details=1&hide_gdpr_banner=1";

export const BOOK_SECTION_ID = "book";

export const scrollToBook = () => {
  const el = document.getElementById(BOOK_SECTION_ID);
  if (el) {
    el.scrollIntoView({ behavior: "smooth" });
    return;
  }
  window.location.assign(`/#${BOOK_SECTION_ID}`);
};
